<template>
    <form-container :headerText="title" :width="1100" action="editSaisonTeams"
                    :valid-actions="['editVereinsdatenblatt']" @save="save()">
        <div v-if="rules" class="px-7 pb-10">
            <v-row>
                <v-col md="4" sm="4" cols="12" class="py-0">
                    <div class="subtitle-2 pb-0 pt-10">Sportanlage</div>
                    <v-text-field v-model="dataObject.sportanlage.name" label="Name" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.sportanlage.strasse" label="Strasse" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.sportanlage.ort" label="Ort" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.sportanlage.telefon" label="Telefon" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.sportanlage.fax" label="Fax" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.sportanlage.email" label="eMail" hide-details>
                    </v-text-field>
                </v-col>
                <v-col md="4" sm="4" cols="12" class="py-0">
                    <div class="subtitle-2 pb-0 pt-10">Obmann/Obfrau</div>
                    <vereinsdatenblatt-edit-person :rules="rules"
                            v-if="dataObject" :data-object="dataObject.obmann">
                    </vereinsdatenblatt-edit-person>
                </v-col>
                <v-col md="4" sm="4" cols="12" class="py-0">
                    <div class="subtitle-2 pb-0 pt-10">Sektionsleiter/in</div>
                    <vereinsdatenblatt-edit-person :rules="rules"
                            v-if="dataObject" :data-object="dataObject.sektionsleiter">
                    </vereinsdatenblatt-edit-person>
                </v-col>
                <v-col cols="12" class="py-0">
                    <div class="subtitle-2 pb-0 pt-10">Bahnen für 4er-Mannschaften</div>
                    <v-text-field style="max-width: 80px" class="mb-2 mr-3 d-inline-block" v-model="dataObject.sportanlage.bahnen.viererTeam.von"
                                  label="von Bahn" hide-details/>
                    <v-text-field style="max-width: 80px" class="d-inline-block" v-model="dataObject.sportanlage.bahnen.viererTeam.bis"
                                  label="bis Bahn" hide-details/>
                    <div class="subtitle-2 pb-0 pt-3">Bahnen für 6er-Mannschaften</div>
                    <v-text-field style="max-width: 80px" class="mb-2 mr-3 d-inline-block" v-model="dataObject.sportanlage.bahnen.sechserTeam.von"
                                  label="von Bahn" hide-details/>
                    <v-text-field style="max-width: 80px" class="d-inline-block" v-model="dataObject.sportanlage.bahnen.sechserTeam.bis"
                                  label="bis Bahn" hide-details/>
                </v-col>
                <!--<v-col md="3" sm="6" cols="12" class="py-0">
                    <div class="subtitle-2 pb-0 pt-10">Sportkapitän/in</div>
                    <vereinsdatenblatt-edit-person :rules="rules"
                            v-if="dataObject" :data-object="dataObject.sportkapitaen">
                    </vereinsdatenblatt-edit-person>
                </v-col>-->
            </v-row>
            <v-row>
                <v-col class="py-0">
                    <div class="subtitle-2 pb-0 pt-8">Team</div>
                    <v-text-field v-model="dataObject.trainerTeam.trainer" label="Trainer" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.trainerTeam.instruktor" label="Instruktoren" hide-details>
                    </v-text-field>
                    <v-text-field v-model="dataObject.trainerTeam.uebungsleiter" label="Übungsleiter" hide-details>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="subtitle-2 pb-0 pt-8 pb-5">Sportkapitäne / Sportkapitäninnen</div>
                    <v-btn class="primary" @click="addSportKapitaen()">
                        <span class="mr-1" v-if="dataObject.sportkapitaene.length>0">Weiteren </span>
                        Kapitän/in hinzufügen
                    </v-btn>
                </v-col>
                <v-col v-for="(sportkapitaen, i) in dataObject.sportkapitaene"
                       :key="i" md="4" sm="4" cols="12" class="py-0">
                    <div class="subtitle-2 pb-0 pt-3">
                        <v-btn icon @click="deleteSportkapitaen(i)">
                            <v-icon class="mr-2">mdi-delete</v-icon>
                        </v-btn>Sportkapitän/in
                    </div>
                    <vereinsdatenblatt-edit-person :rules="rules" class="mb-5" :isSportkapitaen="true"
                                                   v-if="dataObject" :data-object="sportkapitaen">
                    </vereinsdatenblatt-edit-person>
                </v-col>
            </v-row>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import {Sportkapitaen, Vereinsdatenblatt} from "../../../services/data/vereinsdatenblatt";
    import {FormRules} from "../../../services/formRules";
    import VereinsdatenblattEditPerson from "./vereinsdatenblattEditPerson";

    export default {
        components: {
            VereinsdatenblattEditPerson,
            FormContainer},
        name: "vereinsdatenblatt-edit",
        props: ['currentData', 'selectedVereinId'],
        computed: {
            title(){ return this.currentData ? 'Daten ändern' : 'Daten anlegen'},
            user(){ return this.$store.state.user; },
        },
        data: () => ({
            rules: null,
            dataObject: null,
            error: '',
            landesverband: null,
            lvIdSelected: null,
        }),
        created(){
            this.rules = new FormRules();
            this.dataObject = new Vereinsdatenblatt();
            if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
                console.error ("this.currentData", this.currentData);
                console.error ("dataObject", this.dataObject);
                if ( !this.currentData.sportanlage.bahnen ) {
                    this.dataObject.sportanlage.bahnen = {
                        viererTeam: {von: 1, bis: 4},
                        sechserTeam: {von: 1, bis: 4},
                    }
                }
            }
        },
        methods: {
            addSportKapitaen(){
                this.dataObject.sportkapitaene.push(new Sportkapitaen());
            },
            deleteSportkapitaen(i){
                this.dataObject.sportkapitaene.splice(i,1)
            },
            async save(){
                this.$store.state.local.loader = true;
                this.dataObject.sportanlage.bahnen.viererTeam.von = parseInt(this.dataObject.sportanlage.bahnen.viererTeam.von)
                this.dataObject.sportanlage.bahnen.viererTeam.bis = parseInt(this.dataObject.sportanlage.bahnen.viererTeam.bis)
                this.dataObject.sportanlage.bahnen.sechserTeam.von = parseInt(this.dataObject.sportanlage.bahnen.sechserTeam.von)
                this.dataObject.sportanlage.bahnen.sechserTeam.bis = parseInt(this.dataObject.sportanlage.bahnen.sechserTeam.bis)
                let reply = null;
                if ( this.dataObject.id ) {
                    reply = await this.dataObject.saveEdited();
                } else {
                    this.dataObject.id = this.selectedVereinId ? this.selectedVereinId : this.user.permissions.spielbericht;
                    reply = await this.dataObject.saveNew('document');
                }
                this.$store.state.local.loader = false;
                if ( reply.successful ) {
                    window.history.back();
                } else {
                    //error handling
                }
            }
        },
    }
</script>

<style scoped>

</style>